export const PAYPAL_BUTTON_SETTINGS = {
  shape: 'rect',
  height: 44,
  tagline: false,
  label: 'checkout',
};
